exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disabled {\r\n    opacity: 0.1;\r\n    cursor: not-allowed;     \r\n    pointer-events: none;  \r\n}\r\n.hyperlink-content {\r\n    cursor: pointer;\r\n    color: #0073AB;\r\n}\r\na:hover {\r\n    text-decoration: none;\r\n    cursor: pointer;\r\n}\r\n::ng-deep .dlgCss.ui-dialog.ui-widget.ui-widget-content.ui-corner-all.ui-shadow.ui-dialog-draggable {\r\n    max-width: 50vh;\r\n    max-height: 50vh;\r\n    overflow: scroll;\r\n}\r\n.dlgCss{\r\n    width: 50vh !important;\r\n    height: 50vh !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/lookup/wave-ship-reship-popup/custom-cell-renderers/reship-cell-renderer/reship-cell-renderer.component.css
// module id = ../../../../../src/app/shared/lookup/wave-ship-reship-popup/custom-cell-renderers/reship-cell-renderer/reship-cell-renderer.component.css
// module chunks = main